import { columnsKeys, leadTypes } from "utils/constants";
import {
  admin,
  adminLeadColumnsOrder,
  callRecordColumnsOrder,
  columnsHeader,
  individualPropertyUnitColumnsOrder,
  isPolishLead,
  keysToExcludeFromLeadTableState,
  objectKeys,
  polishedLeadColumnsOrder,
  propertyUnitColumnsOrder,
  rawLeadColumnsOrder,
  salesColumnsOrder,
  staffTargetColumnsOrder,
  taskColumnsOrder,
  tokenColumnsOrder,
} from "./constants";

const { rawLead, polishedLead } = leadTypes;

type GetPaginatedUrlParamsTypes = {
  pageNumber: number;
  endpoint: string;
  limit?: number;
};

const { user } = objectKeys;
const { action, assignedUser } = columnsKeys;

export function getPaginatedUrl({
  pageNumber,
  endpoint,
  limit = 20,
}: GetPaginatedUrlParamsTypes) {
  const offset = (pageNumber - 1) * limit;

  return `${endpoint}/?limit=${limit}&offset=${offset}`;
}

export function getErrorMessage(error: any) {
  return (
    error?.response?.data?.error_message ||
    error?.response?.data?.error ||
    error?.message ||
    "Something went wrong"
  );
}

type GetPaginatedUrlWithSearchParamsTypes = {
  pageNumber: number;
  endpoint: string;
  searchParams?: { [key: string]: string };
  limit?: number;
};

export function getPaginatedUrlWithSearchParams({
  pageNumber,
  endpoint,
  searchParams = {},
  limit = 20,
}: GetPaginatedUrlWithSearchParamsTypes) {
  const offset = (pageNumber - 1) * limit;

  // Construct base query parameters
  const queryParams: any = { limit, offset, ...searchParams };

  // Convert query parameters to a query string
  const queryString = new URLSearchParams(queryParams).toString();

  return `${endpoint}/?${queryString}`;
}

export function dataManipulationForRawLeadTableState(data: any) {
  if (!data) {
    return [];
  }

  const isAdmin = !!(data[user]?.role === admin);

  return {
    tableId: data["id"],
    state: Object.keys(data)
      .filter((key: string) => {
        if (keysToExcludeFromLeadTableState.includes(key)) {
          return false;
        }

        // if ((key === action || key === assignedUser) && !isAdmin) {
        //   return false;
        // }

        return true;
      })
      .map((key: string) => {
        return {
          key,
          show: data[key],
          header: columnsHeader[key],
          order: rawLeadColumnsOrder[key],
        };
      })
      .sort((a: any, b: any) => {
        if (a.key === "action") return 1; // always push 'action' to the end
        if (b.key === "action") return -1;
        return a.order < b.order ? -1 : 1;
      }),
  };
}

export function dataManipulationForPolishedLeadTableState(data: any) {
  if (!data) {
    return [];
  }

  const isAdmin = !!(data[user]?.role === admin);

  return {
    tableId: data["id"],
    state: Object.keys(data)
      .filter((key: string) => {
        if (keysToExcludeFromLeadTableState.includes(key)) {
          return false;
        }

        // if ((key === action || key === assignedUser) && !isAdmin) {
        //   return false;
        // }

        return true;
      })
      .map((key: string) => {
        return {
          key,
          show: data[key],
          header: columnsHeader[key],
          order: polishedLeadColumnsOrder[key],
        };
      })
      .sort((a: any, b: any) => {
        if (a.key === action) return 1; // always push 'action' to the end
        if (b.key === action) return -1;

        return a.order < b.order ? -1 : 1;
      }),
  };
}

export function dataManipulationForTaskTableState(data: any) {
  if (!data) {
    return [];
  }

  const isAdmin = !!(data[user]?.role === admin);

  return {
    tableId: data["id"],
    state: Object.keys(data)
      .filter((key: string) => {
        if (keysToExcludeFromLeadTableState.includes(key)) {
          return false;
        }

        // if ((key === action || key === assignedUser) && !isAdmin) {
        //   return false;
        // }

        return true;
      })
      .map((key: string) => {
        return {
          key,
          show: data[key],
          header: columnsHeader[key],
          order: taskColumnsOrder[key],
        };
      })
      .sort((a: any, b: any) => {
        if (a.key === action) return 1; // always push 'action' to the end
        if (b.key === action) return -1;
        return a.order < b.order ? -1 : 1;
      }),
  };
}

export function dataManipulationForCallRecordTableState(data: any) {
  if (!data) {
    return [];
  }

  const isAdmin = !!(data[user]?.role === admin);

  return {
    tableId: data["id"],
    state: Object.keys(data)
      .filter((key: string) => {
        if (keysToExcludeFromLeadTableState.includes(key)) {
          return false;
        }

        // if ((key === action || key === assignedUser) && !isAdmin) {
        //   return false;
        // }

        return true;
      })
      .map((key: string) => {
        return {
          key,
          show: data[key],
          header: columnsHeader[key],
          order: callRecordColumnsOrder[key],
        };
      })
      .sort((a: any, b: any) => {
        if (a.key === action) return 1; // always push 'action' to the end
        if (b.key === action) return -1;
        return a.order < b.order ? -1 : 1;
      }),
  };
}

export function dataManipulationForAdminLead(data: any) {
  if (!data) {
    return [];
  }
  return data.map((item: any) => {
    return {
      ...item,
      select: false,
    };
  });
}

export function dataManipulationForAdminLeadTableState(data: any) {
  if (!data) {
    return [];
  }

  const isAdmin = !!(data[user]?.role === admin);

  return {
    tableId: data["id"],
    state: Object.keys(data)
      .filter((key: string) => {
        if (keysToExcludeFromLeadTableState.includes(key)) {
          return false;
        }

        // if ((key === action || key === assignedUser) && !isAdmin) {
        //   return false;
        // }

        return true;
      })
      .map((key: string) => {
        return {
          key,
          show: data[key],
          header: columnsHeader[key],
          order: adminLeadColumnsOrder[key],
        };
      })
      .sort((a: any, b: any) => {
        return a.order < b.order ? -1 : 1;
      }),
  };
}

export function dataManipulationForPropertyTableState(data: any) {
  if (!data) {
    return [];
  }

  const isAdmin = !!(data[user]?.role === admin);

  return {
    tableId: data["id"],
    state: Object.keys(data)
      .filter((key: string) => {
        if (keysToExcludeFromLeadTableState.includes(key)) {
          return false;
        }

        // if ((key === action || key === assignedUser) && !isAdmin) {
        //   return false;
        // }

        return true;
      })
      .map((key: string, idx: number) => {
        return {
          key,
          show: data[key],
          header: columnsHeader[key],
          order: propertyUnitColumnsOrder[key] ?? 10,
        };
      })
      .sort((a: any, b: any) => {
        if (a.key === action) return 1; // always push 'action' to the end
        if (b.key === action) return -1;
        return a.order < b.order ? -1 : 1;
      }),
  };
}

export function dataManipulationForIndividualPropertyTableState(data: any) {
  if (!data) {
    return [];
  }

  const isAdmin = !!(data[user]?.role === admin);

  return {
    tableId: data["id"],
    state: Object.keys(data)
      .filter((key: string) => {
        if (keysToExcludeFromLeadTableState.includes(key)) {
          return false;
        }

        // if ((key === action || key === assignedUser) && !isAdmin) {
        //   return false;
        // }

        return true;
      })
      .map((key: string, idx: number) => {
        return {
          key,
          show: data[key],
          header: columnsHeader[key],
          order: individualPropertyUnitColumnsOrder[key] ?? 10,
        };
      })
      .sort((a: any, b: any) => {
        if (a.key === action) return 1; // always push 'action' to the end
        if (b.key === action) return -1;
        return a.order < b.order ? -1 : 1;
      }),
  };
}

export function dataManipulationForTokenTableState(data: any) {
  if (!data) {
    return [];
  }

  const isAdmin = !!(data[user]?.role === admin);

  return {
    tableId: data["id"],
    state: Object.keys(data)
      .filter((key: string) => {
        if (keysToExcludeFromLeadTableState.includes(key)) {
          return false;
        }

        // if ((key === action || key === assignedUser) && !isAdmin) {
        //   return false;
        // }

        return true;
      })
      .map((key: string, idx: number) => {
        return {
          key,
          show: data[key],
          header: columnsHeader[key],
          order: tokenColumnsOrder[key] ?? 10,
        };
      })
      .sort((a: any, b: any) => {
        if (a.key === action) return 1; // always push 'action' to the end
        if (b.key === action) return -1;
        return a.order < b.order ? -1 : 1;
      }),
  };
}

export function dataManipulationForStaffTargetTableState(data: any) {
  if (!data) {
    return [];
  }

  const isAdmin = !!(data[user]?.role === admin);

  return {
    tableId: data["id"],
    state: Object.keys(data)
      .filter((key: string) => {
        if (keysToExcludeFromLeadTableState.includes(key)) {
          return false;
        }

        // if ((key === action || key === assignedUser) && !isAdmin) {
        //   return false;
        // }

        return true;
      })
      .map((key: string, idx: number) => {
        return {
          key,
          show: data[key],
          header: columnsHeader[key],
          order: staffTargetColumnsOrder[key] ?? 10,
        };
      })
      .sort((a: any, b: any) => {
        if (a.key === action) return 1; // always push 'action' to the end
        if (b.key === action) return -1;
        return a.order < b.order ? -1 : 1;
      }),
  };
}

export function dataManipulationForSalesTableState(data: any) {
  if (!data) {
    return [];
  }

  return {
    tableId: data["id"],
    state: Object.keys(data)
      .filter((key: string) => {
        if (keysToExcludeFromLeadTableState.includes(key)) {
          return false;
        }

        return true;
      })
      .map((key: string, idx: number) => {
        return {
          key,
          show: data[key],
          header: columnsHeader[key],
          order: salesColumnsOrder[key] ?? 10,
        };
      })
      .sort((a: any, b: any) => {
        if (a.key === action) return 1; // always push 'action' to the end
        if (b.key === action) return -1;
        return a.order < b.order ? -1 : 1;
      }),
  };
}

export function polishLeadParam({ searchParamsObj, type }: any) {
  if (searchParamsObj?.phone_number) {
    return {};
  }

  if (type === rawLead) {
    return {
      [isPolishLead]: false,
    };
  }

  if (type === polishedLead) {
    return {
      [isPolishLead]: true,
    };
  }
}
